import React, { useEffect, useState } from "react";

//Helpers
import { fetchWithTokenJSONPost } from "../Helpers/network";

//UI Material
import {
  Button,
  Card,
  Divider,
  Grid,
  Stack,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TablePagination,
  TableRow,
  TextField,
  Typography,
} from "@mui/material";

//Material Icons
import { Add, ArrowBackIos, Search } from "@mui/icons-material";

//Local components
import ErrorBox from "../Components/ErrorBox";
import ProductRow from "../Components/products-page/ProductRow";
import Selector from "../Components/basics/Selector";
import SetProductDrawer from "../Components/drawers/SetProductDrawer";
import DataLoader from "../Components/basics/DataLoader";

//Helpers
import { searchEngine } from "../Helpers/searchEngine";

const productTypes = [
  "Todos",
  "Estaciones de carga/Cargadores",
  "Accesorios/Repuestos",
  "Servicios",
];

export default function Products() {
  // ==========>Component States<==========
  //State for open/close drawer for set product
  const [openDrawer, setOpenDrawer] = useState(false);
  //State for select page
  const [page, setPage] = useState(0);
  //State for manage rows per page
  const [rowsPerPage, setRowsPerPage] = useState(10);
  //State for setting loader for products data
  const [dataLoader, setDataLoader] = useState(false);
  //State for setting error when could not get products data
  const [dataError, setDataError] = useState(false);
  //State for products list
  const [productsList, setProductsList] = useState([]);
  //State for filter selection
  const [productTypeSelection, setProductTypeSelection] = useState(0);
  //State for search data by query
  const [searchQuery, setSearchQuery] = useState("");

  // ==========>Component UseEffects<==========
  //The useEffect checks for token validation
  useEffect(() => {
    getProductsList();
  }, []);

  // ==========> Component Functions <==========
  //Function to manage page selection
  const handleChangePage = (_event, newPage) => {
    setPage(newPage);
  };
  //Function to control rows per page options
  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  //Function for data query
  const filterData = (query, data) => {
    if (!query) {
      return data;
    } else {
      return searchEngine(data, query);
    }
  };

  //Function to select filtered data
  const filterProductsByType = () => {
    switch (productTypeSelection) {
      case 0:
        return productsList;
      case 1:
        return productsList.filter((p) => p.type === "EV_STATION");
      case 2:
        return productsList.filter((p) => p.type === "ACCESSORY");
      case 3:
        return productsList.filter((p) => p.type === "SERVICE");
      default:
        return productsList;
    }
  };

  //Data in the table
  const dataFiltered = filterData(searchQuery, filterProductsByType());

  //Function to get products list
  const getProductsList = async () => {
    setDataLoader(true);
    try {
      const requestResponse = await fetchWithTokenJSONPost(`/products/get`, {
        howMany: 1000,
      });
      const jsonResponse = await requestResponse.json();
      if (requestResponse.status === 200) {
        setProductsList(jsonResponse.data);
      } else {
        if (requestResponse.status === 401) {
          window.location.href = "/";
        }
      }
    } catch (error) {
      setDataError(true);
    }
    setDataLoader(false);
  };

  if (dataLoader) {
    return <DataLoader />;
  }

  return dataError ? (
    <ErrorBox />
  ) : (
    <Grid container spacing={1}>
      <SetProductDrawer
        open={openDrawer}
        setOpen={setOpenDrawer}
        getData={getProductsList}
        isNewProduct={true}
      />
      <Grid item xs={12}>
        <Stack
          direction="row"
          alignItems="center"
          justifyContent="space-between"
          spacing={1}
        >
          <Button
            startIcon={<ArrowBackIos />}
            color="secondary"
            sx={{ color: "white" }}
            variant="contained"
            size="small"
            onClick={() => {
              window.history.back();
            }}
          >
            Volver
          </Button>
          <Button
            variant="contained"
            color="secondary"
            size="small"
            sx={{ color: "white" }}
            endIcon={<Add />}
            onClick={() => {
              setOpenDrawer(true);
            }}
          >
            nuevo PRODUCTO
          </Button>
        </Stack>
      </Grid>
      <Grid item xs={12}>
        <Card raised>
          <Grid container>
            <Grid item xs={12} sx={{ p: 2 }}>
              <Typography variant="h7" fontWeight="bold">
                Registro de productos y servicios
              </Typography>
            </Grid>
            <Grid item xs={12} sx={{ p: 2 }}>
              <Stack direction="row" spacing={1} justifyContent="space-between">
                <Stack spacing={1} sx={{ width: "100%" }}>
                  <Typography variant="body2" fontWeight="bold">
                    Tipo de producto
                  </Typography>
                  <Selector
                    width="100%"
                    content={productTypes}
                    value={productTypeSelection}
                    handleChange={(e) => {
                      setProductTypeSelection(e.target.value);
                    }}
                  />
                </Stack>
                <Stack spacing={1} sx={{ width: "100%" }}>
                  <Typography variant="body2" fontWeight="bold">
                    Buscar un producto
                  </Typography>
                  <TextField
                    id="search-bar"
                    onChange={(e) => {
                      setSearchQuery(e.target.value);
                    }}
                    variant="outlined"
                    placeholder="Buscar..."
                    fullWidth
                    InputProps={{
                      endAdornment: <Search />,
                    }}
                  />
                </Stack>
              </Stack>
            </Grid>
            <Grid item xs={12}>
              <Divider />
            </Grid>
            <Grid item xs={12}>
              <TableContainer>
                <Table aria-label="products-table">
                  <TableHead>
                    <TableRow>
                      <TableCell align="center">
                        <Typography variant="body2" fontWeight="bold">
                          Nombre
                        </Typography>
                      </TableCell>
                      <TableCell align="center">
                        <Typography variant="body2" fontWeight="bold">
                          Detalles
                        </Typography>
                      </TableCell>
                      <TableCell align="center">
                        <Typography variant="body2" fontWeight="bold">
                          Categoría
                        </Typography>
                      </TableCell>
                      <TableCell align="center">
                        <Typography variant="body2" fontWeight="bold">
                          Precio (CRC)
                        </Typography>
                      </TableCell>
                      <TableCell align="center">
                        <Typography variant="body2" fontWeight="bold">
                          Precio (USD)
                        </Typography>
                      </TableCell>
                      <TableCell align="center">
                        <Typography variant="body2" fontWeight="bold">
                          Acciones
                        </Typography>
                      </TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {dataFiltered.length ? (
                      dataFiltered
                        .sort((a, b) => {
                          if (a.productName < b.productName) return -1;
                          if (a.productName > b.productName) return 1;
                          return 0;
                        })

                        .map((product) => (
                          <ProductRow
                            key={`${product.productId}-${product.createdAt}`}
                            product={product}
                            getProducts={() => {
                              getProductsList();
                            }}
                          />
                        ))
                        .slice(
                          page * rowsPerPage,
                          page * rowsPerPage + rowsPerPage
                        )
                    ) : (
                      <TableRow>
                        <TableCell align="center" colSpan={6}>
                          <Typography variant="body2" fontWeight="bold">
                            No hay productos registrados
                          </Typography>
                        </TableCell>
                      </TableRow>
                    )}
                  </TableBody>
                </Table>
              </TableContainer>
              <TablePagination
                component="div"
                count={dataFiltered.length}
                page={page}
                onPageChange={handleChangePage}
                rowsPerPage={rowsPerPage}
                labelRowsPerPage="Filas"
                onRowsPerPageChange={handleChangeRowsPerPage}
              />
            </Grid>
          </Grid>
        </Card>
      </Grid>
    </Grid>
  );
}
